import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const HUB_LOGIN = 'https://codeneutronai.com/login?product=lms';

const Login = () => {
  const { isAuthenticated, bootstrapping, homePath } = useAuth();

  useEffect(() => {
    if (bootstrapping) return;
    if (new URLSearchParams(window.location.search).get('local') === '1') return;
    if (isAuthenticated) {
      window.location.replace(homePath || '/');
      return;
    }
    const hash = (window.location.hash || '').replace(/^#/, '');
    if (new URLSearchParams(hash).get('cn_access')) return;
    window.location.replace(HUB_LOGIN);
  }, [bootstrapping, isAuthenticated, homePath]);

  return (
    <div className="login-page">
      <div className="login-page__grid">
        <aside className="login-brand">
          <div className="brand-mark">CN</div>
          <h1>CodeNeutron LMS</h1>
          <p className="brand-tagline">
            Company sign-in is on CodeNeutronAI. You will not need a second password here.
          </p>
        </aside>
        <main className="login-panel">
          <div className="login-card">
            <header className="login-header">
              <h2>Opening company sign-in</h2>
              <p>Taking you to your CodeNeutronAI workspace.</p>
            </header>
            <a className="login-btn" href={HUB_LOGIN}>
              Continue to CodeNeutronAI
            </a>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Login;
